import React from 'react';
import { AlertCircle } from 'lucide-react';

interface ErrorDisplayProps {
  error?: Error;
  message?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, message }) => {
  const errorMessage = message || error?.message || 'Une erreur est survenue';

  return (
    <div className="flex justify-center items-center min-h-[400px]">
      <div className="bg-red-50 text-red-800 rounded-lg p-4 flex items-center">
        <AlertCircle className="h-5 w-5 mr-2" />
        {errorMessage}
      </div>
    </div>
  );
};